/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Apikeys_CreatingInputs */

const en_settings_apikeys_creating = /** @type {(inputs: Settings_Apikeys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating...`)
};

const zh_settings_apikeys_creating = /** @type {(inputs: Settings_Apikeys_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建中...`)
};

/**
* | output |
* | --- |
* | "Creating..." |
*
* @param {Settings_Apikeys_CreatingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_apikeys_creating = /** @type {((inputs?: Settings_Apikeys_CreatingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Apikeys_CreatingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_apikeys_creating(inputs)
	return zh_settings_apikeys_creating(inputs)
});
export { settings_apikeys_creating as "settings.apikeys.creating" }